/* eslint-disable import/prefer-default-export */

import {
  LOGIN,
  SET_USER_INFO,
  SET_USERNAME,
  SET_EMAIL,
  IS_SHOW_LOGIN_MODAL,
  IS_SHOW_REGISTER_MODAL,
  IS_SHOW_UPDATE_USER_MODAL,
  SET_PASSWORD,
  SET_PHONE_NUMBER,
  IS_EXPIRED_LOGIN,
  SET_HAS_AGREED_TO_RECEIVE_GOGOVAN_UPDATES,
  SET_HAS_AGREED_TO_RECEIVE_THIRD_PARTIES_UPDATES,
} from '../constants';

export function login(email, password) {
  return dispatch =>
    dispatch({
      type: LOGIN,
      payload: { email, password },
    });
}
export function setisNotExpiredLogin() {
  return dispatch =>
    dispatch({
      type: IS_EXPIRED_LOGIN,
    });
}
export function setUserEmail(email) {
  return dispatch =>
    dispatch({
      type: SET_EMAIL,
      payload: email,
    });
}
export function setUserPassword(password) {
  return dispatch =>
    dispatch({
      type: SET_PASSWORD,
      payload: password,
    });
}
export function setUserName(name) {
  return dispatch =>
    dispatch({
      type: SET_USERNAME,
      payload: name,
    });
}
export function setUserPhone(phone) {
  return dispatch =>
    dispatch({
      type: SET_PHONE_NUMBER,
      payload: phone,
    });
}
export function setUserInfo(user) {
  return dispatch =>
    dispatch({
      type: SET_USER_INFO,
      payload: user,
    });
}

export function setIsShowLoginModal() {
  return dispatch =>
    dispatch({
      type: IS_SHOW_LOGIN_MODAL,
    });
}

export function setIsShowRegisterModal() {
  return dispatch =>
    dispatch({
      type: IS_SHOW_REGISTER_MODAL,
    });
}

export function setIsShowUpdateUserModal() {
  return dispatch =>
    dispatch({
      type: IS_SHOW_UPDATE_USER_MODAL,
    });
}

export function setHaveAgreedToReceiveGogovanUpdates() {
  return dispatch =>
    dispatch({
      type: SET_HAS_AGREED_TO_RECEIVE_GOGOVAN_UPDATES,
    });
}

export function setHaveAgreedToReceiveThirdPartiesUpdates() {
  return dispatch =>
    dispatch({
      type: SET_HAS_AGREED_TO_RECEIVE_THIRD_PARTIES_UPDATES,
    });
}



// WEBPACK FOOTER //
// ./src/actions/user.js